import Action from '../../model/Action'
import State from '../../model/State'

export function entidadeReducer(state: State, action: Action) {
    switch (action.type) {
    case 'setEntidades':
        return {
            ...state,
            entidades: {
                ...state.entidades, items: action.payload
            }
        }
    case 'setTotal':
        return {
            ...state,
            entidades: {
                ...state.entidades, total: action.payload
            }
        }
    case 'setIsLoading':
        return {
            ...state,
            entidades: {
                ...state.entidades, isLoading: action.payload
            }
        }
    case 'setCurrentEntidade':
        return {
            ...state,
            currentEntidade: { ...action.payload }
        }
    default:
        return state
    }
}
